module.exports = __webpack_public_path__ + "img/map12.ea3b3603.png";